export default "__VITE_ASSET__d129c0aa__"